import { TOGGLE } from '../actions/types';

export default function (state = true, action) {
  switch (action.type) {
    case TOGGLE:
      return !state;
    default:
      return state;
  }
}
